import {translate} from "@helpers/translate"
import {useRouter} from "next/router"
import {FC} from "react"

interface TranslateProps {
	children: string | undefined
	capitalize?: boolean
	capitalizeFirst?: boolean
}

export const Translate: FC<TranslateProps> = ({
	children,
	capitalize = false,
	capitalizeFirst = false,
}) => {
	const router = useRouter()
	const {locale} = router

	const translatedText = children
		? translate(children, locale || "en")
		: children

	return <>{translatedText}</>
}
